<template>
  <div class="radio-button">
    <input
      :id="radioButtonId"
      type="radio"
      :name="name"
      :value="value"
      :checked="isChecked"
      :disabled="disabled"
      @change="handleChange"
      class="radio-button__input"
    />
    <label :for="radioButtonId" class="radio-button__label">
      <span class="radio-button__custom"></span>
      <span class="radio-button__text">
        <slot />
      </span>
    </label>
  </div>
</template>

<script>
import { RandomId } from '@/shared/lib/random';

const { generateRandomId } = RandomId();

export default {
  model: {
    prop: 'modelValue',
    event: 'input',
  },
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number, Boolean],
      required: true
    },
    modelValue: {
      type: [String, Number, Boolean],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      radioButtonId: this.generateRandomId('radio-button-'),
    };
  },
  computed: {
    isChecked() {
      return this.modelValue === this.value;
    }
  },
  methods: {
    generateRandomId,
    handleChange() {
      this.$emit('input', this.value);
    }
  },
};
</script>

<style scoped lang="scss">
.radio-button {
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  &__input {
    display: none;

    &:checked + .radio-button__label .radio-button__custom {
      background: rgba(8, 160, 247, 0.08);

      &::after {
        opacity: 1;
      }
    }

    &:disabled + .radio-button__label {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }

  &__label {
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
  }

  &__custom {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    min-width: 24px;
    border: 1px solid #0A77FF;
    border-radius: 50%;
    background: rgba(8, 160, 247, 0.08);
    transition: all 0.2s ease;
    margin-right: 8px;

    &::after {
      content: '';
      width: 12px;
      height: 12px;
      background-color: #0A77FF;
      border-radius: 50%;
      opacity: 0;
      transition: opacity 0.2s ease;
    }
  }

  &__text {
    font-family: 'Geist', sans-serif;
    font-weight: 500;
    font-size: 16px;
    color: #09090B;
  }
}
</style>
